import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "external", "url", "use", "useZorse", "trackInteractionFromCard"];
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { View } from 'foundations-components/components/View';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import SharedKnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { useTracker } from '../../hooks/tracking';
import { KNOWLEDGE_BASE_URL } from '../../utils/urls';
import emptyFn from '../../utils/emptyFn';
import { jsx as _jsx } from "react/jsx-runtime";
const KnowledgeBaseButton = _ref => {
  let {
      children,
      external = false,
      url,
      use,
      useZorse = true,
      trackInteractionFromCard = emptyFn
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackUserInteraction
  } = useTracker();
  const cleanedUrl = useMemo(() => {
    return url && url.replace(KNOWLEDGE_BASE_URL, '');
  }, [url]);
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: use === 'link' ? '200' : undefined,
    marginInlineStart: use === 'link' ? '0' : undefined,
    children: /*#__PURE__*/_jsx(SharedKnowledgeBaseButton, Object.assign({
      external: external,
      onClick: () => {
        trackUserInteraction('click knowledge base link', cleanedUrl);
        trackInteractionFromCard('click knowledge base link', {
          cleanedUrl
        });
      },
      url: url,
      use: use,
      useZorse: useZorse
    }, props, {
      children: children
    }))
  });
};
KnowledgeBaseButton.propTypes = Object.assign({}, SharedKnowledgeBaseButton.propTypes, {
  trackInteractionFromCard: PropTypes.func.isRequired
});
export default KnowledgeBaseButton;